import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BsModalRef, BsModalService }  from 'ngx-bootstrap/modal';
import { BaseViewComponent } from 'projects/shared/core/interfaces/baseViewComponent';
import { LookupService } from 'projects/shared/core/services/lookup.service';
import { PatientService } from 'projects/jpats/app/api/services/patient.service';

@Component({
  selector: 'register-incoming',
  templateUrl: './register-incoming.component.html',
  styleUrls: ['./register-incoming.component.scss']
})
export class RegisterIncomingComponent extends BaseViewComponent {
  @Output() complete = new EventEmitter();
  healthStatuses:any[] = [];
  patientKey:string;
  patientName:string;
  healthStatus:any;
  constructor(
    public bsModalRef: BsModalRef,
    private _patientService: PatientService,
    private _lookupService: LookupService) {
    super(_lookupService);
  }

  ngAfterViewInit() {
    if (this.lookupService.get("PatientHealthStatuses")) {
      this.healthStatuses = this.lookupService.get("PatientHealthStatuses").filter((i)=>i.key !=='3000.4');
    }
    else {
      this.safeSubscribe(this._patientService.Get(), data => {
        this.healthStatuses = data.lookups["PatientHealthStatuses"].filter(i => i.key !== '3000.4');
      })
    }
  }

  register(){
      if (this.healthStatus == null) {
          alert('Health Status cannot be null!')
          return;
      }
    this.bsModalRef.hide();
    let lhealthStatus = this.healthStatuses.find(i=>i.key == this.healthStatus);
    this.complete.emit({patientKey:this.patientKey,patientRegistrationModel:{healthStatus:lhealthStatus}});
  }
}
